// @ts-nocheck

// App
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useYieldCallback } from '@zillow/yield-callback';

// Components
import Checkbox from 'app/shared/modules/MobileSRP/__BaseComponents__/Checkbox/index';

// Hooks
import { useFilterChange } from 'app/shared/modules/filter/FilterBar/hooks';

// Misc / utils
import {
  GeneralFilterHeader,
  GeneralFilterLabel,
  GeneralFilterResetButton,
  GeneralFilterSection,
} from 'app/shared/modules/filter/FilterBar/styles';
import { DEFAULT } from 'app/shared/models/Filter';
import * as S from './styles';
import { emitTrackPetsFilterEvent } from 'app/shared/models/Clickstream/FilterClickstreamEvents';

const PetFilter = ({ showResetButton = false }) => {
  // Redux
  const petState = useSelector((state) => state.filter.pets);
  const [filterState, setFilterState] = useState(petState);
  const [isLoaded, setIsLoaded] = useState(false);

  // Hooks
  const { debouncedFilterChange, reduxOnlyChange, resetFilter, isFilterResetting } = useFilterChange();

  const handleResetClick = useYieldCallback(() => {
    resetFilter({ pets: DEFAULT.pets });
    setFilterState({ cats: false, dogs: false });
  });

  const handleTracking = (state) => {
    const isTrue = state === true;

    if (isTrue) {
      emitTrackPetsFilterEvent({ triggerLocation: 'search_results' });
    }
  };

  const yieldHandleOptionClick = useYieldCallback((option) => {
    // NOTE: Polyfill or use Lodash for desktop migration
    const change = Object.assign({}, filterState);
    change[option] = !filterState[option];
    setFilterState({ ...filterState, [option]: !filterState[option] });
    handleTracking(!filterState[option]);
  });

  const handleOptionClick = (e) => {
    const option = e.currentTarget.getAttribute('data-option-value');

    // Guard against null/undefined option
    if (!option) return;

    yieldHandleOptionClick(option);
  };

  useEffect(() => {
    if (!isLoaded) {
      setIsLoaded(true);
    } else {
      if (!isFilterResetting) {
        reduxOnlyChange({ pets: filterState });
      }
    }
  }, [filterState]);

  return (
    <GeneralFilterSection>
      <GeneralFilterHeader>
        <GeneralFilterLabel>Pets</GeneralFilterLabel>
        {showResetButton && (
          <GeneralFilterResetButton onClick={handleResetClick} aria-label={'Reset all active pet filters'}>
            Reset
          </GeneralFilterResetButton>
        )}
      </GeneralFilterHeader>
      <S.FlexSection>
        <Checkbox
          data-option-value={'dogs'}
          onChange={handleOptionClick}
          isChecked={filterState.dogs}
          ariaLabel={'Allows dogs'}
          flex
        >
          Allows dogs
        </Checkbox>
        <Checkbox
          data-option-value={'cats'}
          onChange={handleOptionClick}
          isChecked={filterState.cats}
          ariaLabel={'Allows cats'}
          flex
        >
          Allows cats
        </Checkbox>
      </S.FlexSection>
    </GeneralFilterSection>
  );
};

export default PetFilter;
